import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';

export interface TextModalData {
  title?: string;
  message?: string;
  buttonText?: string;
}

@Component({
  selector: 'wfs-text-modal',
  templateUrl: './text-modal.component.html',
  imports: [FormButtonComponent, MatDialogModule]
})
export class TextModalComponent {
  readonly data = inject<TextModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef<TextModalComponent>);

  close(): void {
    this.#dialogRef.close();
  }
}
